import { Button } from "@/components/ui/button";
import { Award, ClipboardCheck, RotateCcw, ArrowRight } from "lucide-react";
import { SaveSession } from "@/components/SaveSession";
import { FurtherReading } from "@/components/FurtherReading";
import { band } from "./beatUtils";

export function Debrief({ cfg, debrief, accent, onNext, onRestart }) {
  const s = band(debrief.percent);
  return (
    <div className="space-y-5 fade-up">
      <div className="bg-white border border-emerald-200 rounded-xl p-6 shadow-lg" data-testid="engine-debrief">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-emerald-700 font-semibold mb-5">
          <ClipboardCheck className="w-4 h-4" /><span>Debrief · {debrief.caseTitle}</span>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="flex items-center gap-5">
            <div className={`flex flex-col items-center justify-center w-24 h-24 rounded-2xl border-4 ${s.ring}`} data-testid="debrief-grade">
              <Award className={`w-5 h-5 ${s.text}`} />
              <span className={`text-4xl font-bold leading-none ${s.text}`} data-testid="debrief-percent">{debrief.percent}</span>
              <span className="text-[10px] text-slate-400 font-semibold">/100</span>
            </div>
            <div>
              <div className={`text-xl font-bold ${s.text}`} data-testid="debrief-band">{s.label}</div>
              <div className="text-xs text-slate-500 mt-1">Cert IV competency</div>
            </div>
          </div>
          <div className="lg:col-span-2" data-testid="debrief-breakdown">
            <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold mb-3">Stage scores</div>
            <div className="space-y-2">
              {debrief.breakdown.map((b, i) => {
                const pct = Math.round((b.earned / b.max) * 100);
                return (
                  <div key={b.key || i} data-testid={`debrief-stage-${b.key || i}`}>
                    <div className="flex items-center justify-between text-xs mb-0.5">
                      <span className="text-slate-700 font-medium">{b.label || cfg.steps[i]}</span>
                      <span className="font-mono-clinical font-semibold text-slate-800">{b.earned}/{b.max}</span>
                    </div>
                    <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                      <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: pct >= 80 ? "#10b981" : pct >= 50 ? "#f59e0b" : "#ef4444" }} />
                    </div>
                    {b.detail && <div className="text-[10px] text-slate-500 mt-0.5">{b.detail}</div>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <Button onClick={onNext} data-testid="next-case-btn" className="text-white" style={{ background: accent }}>
            Next scenario <ArrowRight className="w-4 h-4 ml-1.5" />
          </Button>
          <Button onClick={onRestart} variant="outline" data-testid="restart-btn" className="text-slate-600">
            <RotateCcw className="w-4 h-4 mr-1.5" /> Back to start
          </Button>
        </div>
      </div>
      <SaveSession simulatorId={cfg.simId} simulatorName={cfg.simName} score={debrief.percent} grade={s.label} summary={`${debrief.caseTitle} · ${s.label}`} />
      <FurtherReading topic={cfg.topic} />
    </div>
  );
}
